import * as React from 'react';

import {PageTitleBar} from 'shells/layout/page-title-bar';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import {useGetSessionUser} from '../../core/use-get-session-user';
import {PageContainer} from '../../layout';
import {PeanutScheduler} from '../../scheduler/peanut-scheduler';
import {useGetPeanutSchedulerConfig} from '../../scheduler/use-get-peanut-scheduler-config';

import {useGetPersonalizedDemo} from './graphql/hooks/use-get-personalized-demo';

import styles from './sales-demo-page.module.css';

export function SalesDemoPage() {
    const {personalizedDemo} = useGetPersonalizedDemo();
    const {user} = useGetSessionUser();

    const defaultValues = user
        ? // @ts-expect-error
          {'email address': user.emailAddresses[0].address, name: user.name}
        : {};

    const salesMeetingId = personalizedDemo ? personalizedDemo.salesContactMeetingId : null;
    const instanceId = personalizedDemo ? personalizedDemo.instanceId : null;
    const {schedulerConfig} = useGetPeanutSchedulerConfig(
        salesMeetingId,
        instanceId,
        false,
        // @ts-expect-error
        defaultValues
    );

    if (!personalizedDemo || !salesMeetingId || !instanceId || !schedulerConfig) {
        return <LoadingPage padding={0} />;
    }

    return (
        <PageContainer
            title='Sales Demo'
            pageTitleBar={
                <PageTitleBar
                    title='Book a personalized demo'
                    subheaderPrimaryText='Get a full walkthrough of Nutshell or get your specific questions answered by your expert Sales Rep!'
                />
            }
        >
            <div className={styles.container}>
                <div className={styles.profile}>
                    <img src={personalizedDemo.salesContactImageUrl} width={200} />
                    <Stack spacing={16}>
                        <div className={styles.profileContent}>
                            <Body isBold={true}>{personalizedDemo.salesContactName}</Body>
                            <Link
                                href={`mailto:${personalizedDemo.salesContactEmail}`}
                                variant='primary'
                            >
                                {personalizedDemo.salesContactEmail}
                            </Link>
                        </div>
                        <Body>
                            Experienced Account Executive with a solid track record of smashing
                            sales goals and building strong relationships with clients.
                        </Body>
                        <Body>
                            Highly skilled in determining customer preferences and coming up with
                            customized solutions to help the business grow.
                        </Body>
                    </Stack>
                </div>
                <div className={styles.schedulerPreview}>
                    <PeanutScheduler
                        schedulerConfig={JSON.stringify(schedulerConfig)}
                        meetingModelId={salesMeetingId}
                        instanceId={instanceId}
                        viewType='schedule'
                    />
                </div>
            </div>
        </PageContainer>
    );
}
